<div class="row" *ngIf="taxStrategy">
  <div class="small-12 medium-12 columns">
    <div class="row">
      <div class="small-12 medium-12 columns" *ngIf="taxStrategy.opportunities && taxStrategy.opportunities.length > 0">
        <ul class="float-left strategy-view-content" style="margin-left: 30px;margin-bottom: 0px !important;">
          <li *ngFor="let opportunity of taxStrategy.opportunities">{{opportunity.description}}</li>
        </ul>
      </div>
      <div class="small-12 medium-12 columns" *ngIf="!taxStrategy.opportunities || taxStrategy.opportunities.length === 0">
        <div class="small-12 medium-12 columns strategy-view-content">No opportunities available.</div>
      </div>
    </div>
  </div>
</div>

